<template>
  <v-row align="center" justify="center">
    <v-col cols="10">
      <v-progress-linear v-if="$apollo.loading" indeterminate />
      <highcharts v-if="dotsLogged" :options="dotsLoggedReport"></highcharts>
    </v-col>
  </v-row>
</template>

<script>
import { DOTS_LOGGED_QUERY } from "@/graphql/queries/engagement.js";

export default {
  name: "DotsLogged",
  props: {
    startDate: {
      type: String,
    },
    endDate: {
      type: String,
    },
    gymBranch: {
      type: [Number, String],
    },
  },
  data() {
    return {
      dotsLogged: null,
    };
  },
  computed: {
    dotsLoggedReport() {
      let series = this.dotsLogged.map((x) => {
        return {
          name: x["cohort"],
          data: x["engagement"].map((c) => [c["actionDate"], parseInt(c["userCount"])]),
        };
      });
      return {
        chart: {
          type: "line",
        },
        legend: {
          layout: "vertical",
          align: "right",
          verticalAlign: "middle",
        },
        plotOptions: {
          series: {
            label: {
              connectorAllowed: false,
            },
          },
        },
        title: {
          text: "Dots Logged",
        },
        xAxis: {
          categories: this.dotsLogged[0].engagement.map((x) => x["actionDate"]),
        },
        yAxis: {
          title: {
            text: "# of users",
          },
        },
        credits: {
          enabled: false,
        },
        series: series,
      };
    },
  },
  apollo: {
    dotsLogged: {
      query: DOTS_LOGGED_QUERY,
      variables() {
        return {
          startDate: this.startDate,
          endDate: this.endDate,
          gymBranch: this.gymBranch,
        };
      },
    },
  },
};
</script>
